import { Loading, Stack, styled, Text } from 'shell/components';

const GradingRegenerating = (props) => {
    return (
        <RootStack alignItems={'center'} spacing={8} {...props}>
            <Stack alignItems={'center'} spacing={2}>
                <Text align={'center'} component={'p'} variant={'h6'} weight={'semibold'}>
                    Grades are being regenerated
                </Text>
                <Text align={'center'}>
                    Please keep this window open until this process completes. This may take a few minutes.
                </Text>
            </Stack>
            <Loading sx={{ zoom: 0.5 }} />
            {/* <Button color={'neutral'} variant={'tertiary'}>
                Cancel Regeneration
            </Button> */}
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        position: 'relative',
        top: '40%',
        padding: theme.spacing(0, 5),
    };
});

export default GradingRegenerating;
